import RegularProduct from 'components/ProductPage/Type/RegularProduct/RegularProduct';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showHighlightValuePriceOnPDPSelector } from 'viewModel/selectors/testTarget/showHighlightValuePriceOnPDPSelector';

const fields = createStructuredSelector({
    highlightValueHidden: showHighlightValuePriceOnPDPSelector
});

const withHighlightValueVisibilityProps = connect(fields);

export default withHighlightValueVisibilityProps(RegularProduct);
